import { PlusCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import * as React from "react";
import { Link } from "react-router-dom";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";
import { ZUid } from "src/types/zUid";

interface PropsEntityCreateButton {
  objectName: React.ReactNode;
  objectId?: ZUid | null;
  onClick?: () => void;
}

export const EntityCreateButton: React.FC<PropsEntityCreateButton> = ({
  objectName,
  objectId,
  onClick,
}) => {
  const content = (
    <>
      <PlusCircleOutlined /> {objectName}
    </>
  );

  if (onClick) {
    return (
      <Button onClick={onClick} type="primary">
        {content}
      </Button>
    );
  }

  return (
    <Link
      to={makeUrl(PageUrl.entityNew, {
        objectId,
      })}
    >
      <Button type="primary">{content}</Button>
    </Link>
  );
};
